import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const Practice = () => {
  return (
    <Flex flex="1" direction="column">
      <Outlet />
    </Flex>
  );
};
export default Practice;
